import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

const ENDPOINT = "avisoinauguracao";

// O usuário é identificado pela API a partir do token — não enviar usuarioId
const getAvisosPendentes = () =>
    UseGetApiSimple(ENDPOINT);

const confirmarAviso = (estabelecimentoId) =>
    UsePostApi(`${ENDPOINT}/${estabelecimentoId}/confirmar`, {});

// O banner fica no layout da Matriz e só carrega ao montar. Telas que mudam a dtInauguracao
// (alteração, cadastro, migração) disparam este evento para o layout recarregar os avisos.
const AVISOS_INAUGURACAO_ALTERADOS = "avisosInauguracaoAlterados";

const notificarAvisosAlterados = () =>
    window.dispatchEvent(new Event(AVISOS_INAUGURACAO_ALTERADOS));

export {
    getAvisosPendentes,
    confirmarAviso,
    AVISOS_INAUGURACAO_ALTERADOS,
    notificarAvisosAlterados,
};
